import React from 'react';
import { Content } from './Content';
import { BackgroundPage } from '@/components/Layout/BackgroundPage';

export function Check2FA() {
	return (
		<BackgroundPage>
			<Content />
		</BackgroundPage>
	);
}
